/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActivateSurveySeasonPlanBody } from '../models/ActivateSurveySeasonPlanBody';
import type { CreateDraftPlanBody } from '../models/CreateDraftPlanBody';
import type { CreateSurveySeasonBody } from '../models/CreateSurveySeasonBody';
import type { SavePlanSurveyItem } from '../models/SavePlanSurveyItem';
import type { SurveySeason } from '../models/SurveySeason';
import type { SurveySeasonSummaryResponse } from '../models/SurveySeasonSummaryResponse';
import type { SurveySeasonSurveyModuleReplacementItem } from '../models/SurveySeasonSurveyModuleReplacementItem';
import type { SurveySeasonSurveyReplacementRow } from '../models/SurveySeasonSurveyReplacementRow';
import type { SurveySeasonSurveyReviewCutsResponse } from '../models/SurveySeasonSurveyReviewCutsResponse';
import type { SurveySeasonSurveyReviewStatusResponse } from '../models/SurveySeasonSurveyReviewStatusResponse';
import type { SurveySeasonSurveysResponse } from '../models/SurveySeasonSurveysResponse';
import type { UpdateSurveySeasonBody } from '../models/UpdateSurveySeasonBody';
import type { UpdateSurveySeasonStepStatusBody } from '../models/UpdateSurveySeasonStepStatusBody';
import type { UpdateSurveySeasonSurveyReplacementBody } from '../models/UpdateSurveySeasonSurveyReplacementBody';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveySeasonService {

    /**
     * Get survey season
     * @returns SurveySeason Success
     * @throws ApiError
     */
    public static getSurveySeason(): CancelablePromise<SurveySeason> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason',
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create survey season
     * @returns SurveySeason Created
     * @throws ApiError
     */
    public static createSurveySeason({
        requestBody,
    }: {
        requestBody: CreateSurveySeasonBody,
    }): CancelablePromise<SurveySeason> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveySeason',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Update survey season plan note
     * @returns SurveySeason Success
     * @throws ApiError
     */
    public static updateSurveySeason({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: UpdateSurveySeasonBody,
    }): CancelablePromise<SurveySeason> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/surveySeason/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Reset the survey season workflow (BC Super Admin only)
     * Removes all workflow progress: deletes the survey season and its survey selections, and deletes the linked plan. If the plan has been activated, its current flag is cleared before deletion. Restricted to BC Super Admins.
     * @returns void
     * @throws ApiError
     */
    public static resetSurveySeasonWorkflow({
        id,
    }: {
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveySeason/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create a draft plan for survey season
     * @returns SurveySeason Created
     * @throws ApiError
     */
    public static createSurveySeasonPlan({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: CreateDraftPlanBody,
    }): CancelablePromise<SurveySeason> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveySeason/{id}/plan',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update survey season step status
     * @returns SurveySeason Success
     * @throws ApiError
     */
    public static updateSurveySeasonStepStatus({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: UpdateSurveySeasonStepStatusBody,
    }): CancelablePromise<SurveySeason> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/surveySeason/{id}/step-status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get surveys for a survey season plan
     * @returns SurveySeasonSurveyModuleReplacementItem Success
     * @throws ApiError
     */
    public static getPlanSurveys({
        id,
    }: {
        id: number,
    }): CancelablePromise<Array<SurveySeasonSurveyModuleReplacementItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason/{id}/surveys',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Save survey decision for a survey season plan
     * @returns SavePlanSurveyItem Success
     * @throws ApiError
     */
    public static savePlanSurveys({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: Array<SavePlanSurveyItem>,
    }): CancelablePromise<Array<SavePlanSurveyItem>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/surveySeason/{id}/surveys',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Activate the survey season draft plan
     * @returns SurveySeason Success
     * @throws ApiError
     */
    public static activateSurveySeasonPlan({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: ActivateSurveySeasonPlanBody,
    }): CancelablePromise<SurveySeason> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveySeason/{id}/activate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * List survey season enable-surveys grouped by job profile with setup statuses
     * @returns SurveySeasonSurveysResponse Success
     * @throws ApiError
     */
    public static getSurveySeasonEnableSurveys({
        id,
    }: {
        id: number,
    }): CancelablePromise<SurveySeasonSurveysResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason/{id}/enable-surveys',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
                409: `The survey season's plan is not activated; the Enable Surveys step is gated until activation.`,
            },
        });
    }

    /**
     * Export survey season enable-surveys as CSV
     * @returns string Success
     * @throws ApiError
     */
    public static exportSurveySeasonEnableSurveys({
        id,
    }: {
        id: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason/{id}/enable-surveys/export',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
                409: `The survey season's plan is not activated; the Enable Surveys export is gated until activation.`,
            },
        });
    }

    /**
     * Survey season Review & Confirm summary grouped into new / continuing / not-included
     * @returns SurveySeasonSummaryResponse Success
     * @throws ApiError
     */
    public static getSurveySeasonSummary({
        id,
    }: {
        id: number,
    }): CancelablePromise<SurveySeasonSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason/{id}/summary',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get per-survey readiness for the Review Survey Status step
     * @returns SurveySeasonSurveyReviewStatusResponse Success
     * @throws ApiError
     */
    public static getReviewStatusList({
        id,
    }: {
        id: number,
    }): CancelablePromise<SurveySeasonSurveyReviewStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason/{id}/review-status',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export survey season review-status surveys as CSV
     * @returns string Success
     * @throws ApiError
     */
    public static exportSurveySeasonReviewStatus({
        id,
    }: {
        id: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason/{id}/review-status/export',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get the data cuts of a Review survey row (old vs new), with usage counts
     * @returns SurveySeasonSurveyReviewCutsResponse Success
     * @throws ApiError
     */
    public static getSurveyCuts({
        id,
        surveySeasonSurveyReplacementId,
    }: {
        id: number,
        surveySeasonSurveyReplacementId: number,
    }): CancelablePromise<SurveySeasonSurveyReviewCutsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason/{id}/surveys/{surveySeasonSurveyReplacementId}/cuts',
            path: {
                'id': id,
                'surveySeasonSurveyReplacementId': surveySeasonSurveyReplacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Mark the survey refresh workflow complete; clears the season (keeps the activated plan)
     * @returns void
     * @throws ApiError
     */
    public static completeSurveySeason({
        id,
    }: {
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveySeason/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Run the season's survey replacements (create, actualize, auto-decide, publish) asynchronously
     * @returns any Survey replacement run scheduled
     * @throws ApiError
     */
    public static runSurveySeasonSurveyReplacements({
        id,
    }: {
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveySeason/{id}/survey-replacements/run',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update a season survey replacement row's sources and/or comment
     * @returns SurveySeasonSurveyReplacementRow The updated survey replacement row
     * @throws ApiError
     */
    public static updateSurveySeasonSurveyReplacement({
        id,
        surveySeasonSurveyReplacementId,
        requestBody,
    }: {
        id: number,
        surveySeasonSurveyReplacementId: number,
        requestBody: UpdateSurveySeasonSurveyReplacementBody,
    }): CancelablePromise<SurveySeasonSurveyReplacementRow> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/surveySeason/{id}/survey-replacements/{surveySeasonSurveyReplacementId}',
            path: {
                'id': id,
                'surveySeasonSurveyReplacementId': surveySeasonSurveyReplacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Remove a survey from the season by clearing its row's target
     * Clears the row's target survey, the same shape Select Surveys writes when a survey is dropped: prevSurveyIds are kept, so the row stays listed on Select Surveys and its target can be restored there. The module pointer is cleared too once no sibling row of that module still holds a target. Idempotent — a row whose target is already cleared succeeds unchanged. Draft plans only.
     * @returns void
     * @throws ApiError
     */
    public static removeSurveySeasonSurveyReplacementTarget({
        id,
        surveySeasonSurveyReplacementId,
    }: {
        id: number,
        surveySeasonSurveyReplacementId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveySeason/{id}/survey-replacements/{surveySeasonSurveyReplacementId}',
            path: {
                'id': id,
                'surveySeasonSurveyReplacementId': surveySeasonSurveyReplacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Configure a replaced survey as new, severing its previous-edition link
     * Clears the row's previous editions so the survey becomes net-new: it drops out of the replacement groups and into the "other surveys in this plan" bucket. Deactivates the linked survey replacement. Rejected once the replacement is published (Done). Idempotent when the row is already net-new.
     * @returns SurveySeasonSurveyReplacementRow The updated survey replacement row
     * @throws ApiError
     */
    public static configureSurveySeasonSurveyAsNew({
        id,
        surveySeasonSurveyReplacementId,
    }: {
        id: number,
        surveySeasonSurveyReplacementId: number,
    }): CancelablePromise<SurveySeasonSurveyReplacementRow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveySeason/{id}/survey-replacements/{surveySeasonSurveyReplacementId}/configure-as-new',
            path: {
                'id': id,
                'surveySeasonSurveyReplacementId': surveySeasonSurveyReplacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

}
